export default "__VITE_ASSET__89855afd__"